var axios = require("axios");
var axiosCake = require("axios-jsonp-pro");
import { getTokenNode } from "../store/utils/tokenNode";
import store from '@/store';
import router from '@/routes/router';
import { handleCache } from "@/store/utils/cache"

export const cakeBaseURL = process.env.VUE_APP_API_CAKE_URL // cake api
export const nodeBaseURLV1 = process.env.VUE_APP_API_NODE_URL
export const nodeBaseURLV2 = process.env.VUE_APP_API_NODE_URL_V2
export const nodeBaseURLV3 = process.env.VUE_APP_API_NODE_URL_V3
export const bocapioKey = process.env.VUE_APP_BOCAPIO_KEY // coloca lá
export const knowledgeBaseURL = process.env.VUE_APP_KNOWLEDGE_API // coloca lá
export const janooBaseURL = process.env.VUE_APP_API_JANOO_URL
export const janooDevBaseURL = process.env.VUE_APP_API_JANOO_DEV_URL
export const janooApi = axiosCake.create({
  baseURL: janooBaseURL
});

/**
 * Apontamento para  a versão 1 da api Node
 *
 */
export const nodeApi = axios.create({
  baseURL: nodeBaseURLV1,
  /* other custom settings */
  headers: {
    "Access-Control-Allow-Origin": "*",
    Accept: "application/json",
    "Content-Type": "application/json",
    "x-access-token": getTokenNode()
  }
});

nodeApi.defaults.timeout = 18000000;
nodeApi.interceptors.request.use(
  config => {
    const token = getTokenNode()
    if (token) {
      config.headers['x-access-token'] = `${token}`
    }
    return config;
  },
  error => {
    return Promise.reject(error)
  }
);

nodeApi.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response)
    }
    else {
      return Promise.reject(response)
    }
  },
  error => {
    console.error('nodeApi error', error)
    if (error.response.status) {
      // DO SOMETHING
      return Promise.reject(error.response)
    }
  }
);

export const nodeApi3 = axios.create({
  baseURL: nodeBaseURLV3,
  /* other custom settings */
  headers: {
    "Access-Control-Allow-Origin": "*",
    Accept: "application/json",
    "Content-Type": "application/json",
    "x-access-token": getTokenNode()
  }
});

nodeApi3.defaults.timeout = 18000000;
nodeApi3.interceptors.request.use(
  config => {
    config.url = handleCache(config.baseURL + config.url)
    const token = getTokenNode()
    if (token) {
      config.headers['x-access-token'] = `${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

nodeApi3.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    }
    else {
      return Promise.reject(response);
    }
  },
  error => {
    // Sem response = timeout ou falha de rede: devolve o erro do axios (antes
    // quebrava aqui com TypeError ao ler error.response.status)
    if (!error.response) {
      console.error('API request failed without response', {
        url: error.config && error.config.url,
        code: error.code,
        message: error.message,
      });
      return Promise.reject(error);
    }
    console.error('API error response', error.response);
    if (error.response.status == 401) {
      console.error('forcing logout');
      store.dispatch(authLogout)
      //TODO: dar logout no cake. mas é preciso primeiro setar o token cake via vue.js! veja o outro TODO... atualmente é feito via iframe na tela de login... tooosco demais!
      router.push("/login")
    }
    return Promise.reject(error.response);
  }
);



export const cakeApi = axiosCake.create({
  baseURL: cakeBaseURL
});

cakeApi.defaults.timeout = 18000000;
cakeApi.interceptors.request.use(
  // TODO: montar protocolo de comunicação com cake. avaliar token criado pelo iframe na tela de login
  config => {
    const token = getTokenNode()
    if (token) {
      config.headers['x-access-token'] = `${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

cakeApi.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    }
    else {
      return Promise.reject(response);
    }
  },
  error => {
    console.error('ds', error);

    if (error.response.status) {
      // DO SOMETHING
      return Promise.reject(error.response);
    }
  }
);



export const knowledgeApi = axiosCake.create({
  baseURL: knowledgeBaseURL
});

knowledgeApi.defaults.timeout = 18000000;
knowledgeApi.interceptors.request.use(
  config => {
    const token = getTokenNode()
    if (token) {
      config.headers['x-access-token'] = `${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

knowledgeApi.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    }
    else {
      return Promise.reject(response);
    }
  },
  error => {
    console.error('ds', error);

    if (error.response.status) {
      // DO SOMETHING
      return Promise.reject(error.response);
    }
  }
);

janooApi.defaults.timeout = 18000000;
janooApi.interceptors.request.use(
  config => {
    const token = getTokenNode()
    if (token) {
      config.headers['x-access-token'] = `${token}`;
      // config.headers['dataType'] = `jsonp`;
      // config.headers['origin'] = `same`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

janooApi.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    }
    else {
      return Promise.reject(response);
    }
  },
  error => {
    console.error('ds', error);
    if (error.response.status) {
      // DO SOMETHING
      return Promise.reject(error.response);
    }
  }
);
